import { CustomContentProps, SnackbarContent } from "notistack";
import { forwardRef, memo } from 'react';
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(
    (theme, p, classes) => ({
        root: {
            display: "block !important",
            backgroundColor: '#43a047', // green
            fontSize: '0.875rem',
            lineHeight: 1.43,
            letterSpacing: '0.01071em',
            color: '#fff',
            alignItems: 'center',
            padding: '6px 16px',
            borderRadius: '4px',
            boxShadow:
                '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
        },
        lessPadding: {
            paddingLeft: `${8 * 2.5}px`,
        },
        message: {
            display: 'flex',
            alignItems: 'sart',
            padding: '8px 0',
        },
        messageBlock: {
            display: 'flex',
            flexDirection: "column",
            alignItems: 'start',
            gap: theme.spacing(1)
        },
        action: {
            alignItems: 'center',
            "& a": {
                color: "#fff",
                textTransform: "uppercase"
            },
            "& a:hover": {
                color: "#fff",
                fontWeight: "bold"
            }
        },
    })
);

const ariaDescribedby = 'notistack-snackbar';

interface IProps extends CustomContentProps {
}

const MaterialDesignContent = forwardRef<HTMLDivElement, IProps>((props, forwardedRef) => {
    const {
        id,
        message,
        action: componentOrFunctionAction,
        iconVariant,
        hideIconVariant,
        style,
        className,
    } = props;

    const { classes, cx } = useStyles();

    const icon = iconVariant["success"];

    let action = componentOrFunctionAction;
    if (typeof action === 'function') {
        action = action(id);
    }

    return (
        <SnackbarContent
            ref={forwardedRef}
            role="alert"
            aria-describedby={ariaDescribedby}
            style={style}
            className={
                cx(
                    className, classes.root,
                    {
                        [classes.lessPadding]: !hideIconVariant && icon != null
                    }
                )
            }
        >
            <div id={ariaDescribedby} className={classes.message}>
                {!hideIconVariant ? icon : null}
                <div className={classes.messageBlock}>
                    {message}
                    {action && <div className={classes.action}>{action}</div>}
                </div>
            </div>
        </SnackbarContent>
    );
});

MaterialDesignContent.displayName = 'MaterialDesignContent';

export default memo(MaterialDesignContent);
